import React, { useMemo } from 'react'
import { useRemoteConfig } from 'modules/RemoteConfig/hooks/useRemoteConfig'
import { SignUpModal } from 'redesign/components/molecules/SignUpModal'

type SignUpModalProps = {
    setShowModal: (value: boolean) => void
    showModal: boolean
}

export const SignUpModalInfo = ({ setShowModal, showModal }: SignUpModalProps) => {
    const { getConfigByName } = useRemoteConfig()
    const NAC_PHONE_NUMBER: string = useMemo(() => (getConfigByName('NAV_NAC_NUMBER') as string) || '', [getConfigByName])

    return (
        <SignUpModal
            setShowModal={() => {
                setShowModal(!showModal)
            }}
            showModal={showModal}
            title="Não tem acesso a nenhum destes contatos?"
        >
            <p>Validar o seu cadastro através de um código de segurança é fundamental para a criação da sua conta no Nav Dasa.</p>
            <p>
                Se você não conhece ou não tem mais acesso a nenhum destes contatos, entre em contato com nosso time de atendimento e
                atualize seus dados pelo WhatsApp:{' '}
                <a href="https://api.whatsapp.com/send/?phone=551140202117" rel="noreferrer" target="_blank">
                    {NAC_PHONE_NUMBER}
                </a>
            </p>
            <p>Ou volte um passo anterior e crie uma nova senha para acessar.</p>
        </SignUpModal>
    )
}
